<template src="./home.html"></template>

<script>
import { get_kpi } from "@/api/api.dashboard.js";
import { Chart, registerables } from "chart.js";
import { coloreStatoManutenzione } from "@/constants/statoManutenzione.js";
import Functions from "@/utils/functions.js";

Chart.register(...registerables);

const NOMI_MESI = [
  "Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno",
  "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre",
];

export default {
  name: "HomePage",

  data() {
    return {
      kpi: null,
      chart: null,
    };
  },

  computed: {
    ruolo() {
      return this.$store.getters["user/getRole"];
    },
    // Visualizzatore: sola lettura, non deve vedere l'azione rapida "Nuova Manutenzione".
    puoScrivere() {
      return this.ruolo === "SuperAdmin" || this.ruolo === "Admin" || this.ruolo === "Operatore";
    },
    // Pagamenti/Incassi: dati riservati all'Admin, come le rispettive pagine
    // (il backend comunque non calcola/invia questi campi per gli altri ruoli:
    // questo controllo evita solo di mostrare una sezione vuota).
    mostraFinanziario() {
      return this.ruolo === "Admin";
    },
    meseCorrente() {
      return NOMI_MESI[new Date().getMonth()];
    },
    totalePerTipo() {
      if (!this.kpi || !this.kpi.manutenzioniPerTipo) return 0;
      return this.kpi.manutenzioniPerTipo.reduce((somma, t) => somma + t.conteggio, 0);
    },
  },

  mounted() {
    this.init();
  },

  beforeUnmount() {
    if (this.chart) this.chart.destroy();
  },

  methods: {
    async init() {
      try {
        const res = await get_kpi();
        this.kpi = res.data;
        await this.$nextTick();
        this.renderChart();
      } catch (error) {
        console.log(error);
      }
    },

    renderChart() {
      if (!this.$refs.chartTipo) return;
      if (!this.kpi || !this.kpi.manutenzioniPerTipo || this.kpi.manutenzioniPerTipo.length === 0) return;

      if (this.chart) {
        this.chart.destroy();
        this.chart = null;
      }

      const labels = this.kpi.manutenzioniPerTipo.map((t) => t.nome);
      const dati = this.kpi.manutenzioniPerTipo.map((t) => t.conteggio);
      const colori = this.kpi.manutenzioniPerTipo.map((t) => t.colore || "#1976D2");

      this.chart = new Chart(this.$refs.chartTipo, {
        type: "bar",
        data: {
          labels,
          datasets: [
            {
              data: dati,
              backgroundColor: colori,
              borderRadius: 4,
              maxBarThickness: 22,
            },
          ],
        },
        options: {
          indexAxis: "y",
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { display: false },
            tooltip: {
              callbacks: {
                label: (ctx) => `${ctx.parsed.x} (${this.percentuale(ctx.parsed.x)}%)`,
              },
            },
          },
          scales: {
            x: { beginAtZero: true, ticks: { precision: 0 } },
          },
        },
      });
    },

    percentuale(conteggio) {
      if (!this.totalePerTipo) return 0;
      return Math.round((conteggio / this.totalePerTipo) * 100);
    },

    formattaTempoMedio: Functions.formattaDurataMinuti,

    formattaData(data) {
      if (!data) return "";
      return new Date(data).toLocaleString("it-IT", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },

    formatSoloData(data) {
      return data ? new Date(data).toLocaleDateString("it-IT") : "—";
    },

    formattaImporto(importo) {
      return (importo || 0).toLocaleString("it-IT", { style: "currency", currency: "EUR" });
    },

    coloreStato: coloreStatoManutenzione,

    vaiCalendario() {
      this.$router.push("/calendario");
    },
    vaiStorico() {
      this.$router.push("/storico");
    },
    vaiMacchine() {
      this.$router.push("/macchine");
    },
    vaiMagazzino() {
      this.$router.push("/magazzino");
    },
    vaiMacchinaDettaglio(id) {
      this.$router.push(`/macchine/${id}`);
    },
    vaiMezzi() {
      this.$router.push("/mezzi");
    },
    vaiPagamenti() {
      this.$router.push("/pagamenti");
    },
    vaiIncassi() {
      this.$router.push("/incassi");
    },
  },
};
</script>

<style scoped>
/* Pallino colore d'ambito davanti al titolo di ogni sezione della dashboard
   (bg-manutenzioni/bg-mezzi/bg-amministrazione arrivano dai colori tema
   definiti in main.js). */
.ambito-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 8px;
}
</style>